import styled, { css } from 'styled-components';

export const Box = styled.div<{ $isOpen: boolean }>`
  left: 50%;
  transform: translateX(-50%);
  background-color: ${({ theme }) => theme.palette.primary.background};
  border-radius: 14px;
  z-index: 3;
  position: fixed;
  border: 1px solid ${({ theme }) => theme.palette.primary.border};
  bottom: 20px;
  top: auto;
  padding: 18px 15px;
  width: calc(100% - 40px);

  ${({ $isOpen }) =>
    $isOpen
      ? css`
          visibility: visible;
          opacity: 1;
          transition: visibility 0s linear 0s, opacity 300ms;
        `
      : css`
          visibility: hidden;
          opacity: 0;
          transition: visibility 0s linear 300ms, opacity 300ms;
        `}
`;
